import styled, { keyframes } from 'styled-components';
import { hideVisually } from 'polished';
import { prefix } from '../../tools/settings';
var height = {
  large: '1rem',
  medium: '0.75rem',
  small: '0.5rem',
  xsmall: '0.25rem'
};
var AnimationStripe = keyframes(["from{background-position:0 0}to{background-position:1rem 0}"]);
export var StyledProgress = styled.div.withConfig({
  displayName: "ProgressBarstyles__StyledProgress",
  componentId: "sc-73du99-0"
})(["display:block;height:", ";border-radius:100px;width:100%;position:relative;line-height:1;overflow:hidden;background:var(--dentsu-color-n150);&.", "-progress-bar--stripe{.", "-progress-bar__indicator::before{content:'';position:absolute;top:0;left:0;height:100%;width:100%;background-image:linear-gradient( 45deg,rgba(255,255,255,0.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,0.15) 50%,rgba(255,255,255,0.15) 75%,transparent 75%,transparent );background-repeat:repeat-x;background-size:1rem 1rem;}}&.", "-progress-bar--animated{.", "-progress-bar__indicator::before{animation:", " var(--denstu-motion-duration-moderate) linear infinite;}}"], function (props) {
  return height[props.size];
}, prefix, prefix, prefix, prefix, AnimationStripe);
export var StyledProgressBar = styled.div.withConfig({
  displayName: "ProgressBarstyles__StyledProgressBar",
  componentId: "sc-73du99-1"
})(["display:block;position:relative;background:var(--dentsu-color-fuchsia);width:", ";transition:width var(--denstu-motion-duration-moderate) var(--denstu-motion-easing-standard);height:100%;border-radius:inherit;"], function (props) {
  return props.width;
});
export var StyledProgressLabel = styled.span.withConfig({
  displayName: "ProgressBarstyles__StyledProgressLabel",
  componentId: "sc-73du99-2"
})(["", ";"], hideVisually);